import { useState } from 'react';
import Dialog from './Dialog';
import { Text } from '../general/Text';
import { en } from '../../locales/en';
import { AsyncAction } from '../../types/general/asyncAction';
import { useGcsStore } from '../../store/useGcsStore';
import type { VehicleId } from '../../types/gcs/vehicle';
import type { MissionId } from '../../types/gcs/mission';
import { useLocalizedErrorMessage } from '../../hooks/useLocalizedErrorMessage';
import { getShortVehicleId } from '../../utils/formatters';

interface ConfirmFtsDialogProps {
  gcsId: string;
  vehicleId: VehicleId;
  missionId: MissionId;
  onClose: () => void;
}

function ConfirmFtsDialog({ gcsId, vehicleId, missionId, onClose }: ConfirmFtsDialogProps) {
  const getLocalizedErrorMessage = useLocalizedErrorMessage();
  const [ftsAction, setFtsAction] = useState<AsyncAction>(AsyncAction.initial());
  const triggerParachute = useGcsStore((state) => state.triggerParachute);
  const vehicleLabel = getShortVehicleId(vehicleId);

  const onConfirmClicked = async () => {
    try {
      setFtsAction(AsyncAction.loading());
      await triggerParachute(gcsId, missionId);
      setFtsAction(AsyncAction.success(undefined));
      onClose();
    } catch (error) {
      setFtsAction(AsyncAction.failure(error));
    }
  };

  return (
    <Dialog
      title={en.confirmFtsDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmFtsDialog.ftsButton,
        callback: onConfirmClicked,
        isLoading: ftsAction.isLoading,
        backgroundColor: 'var(--color-danger)',
        foregroundColor: '#ffffff'
      }}
      errorText={ftsAction.isFailure ? getLocalizedErrorMessage(ftsAction.error) : undefined}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmFtsDialog.body.replace('{vehicle}', vehicleLabel)}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmFtsDialog;
